module.exports = __webpack_public_path__ + "img/a1.617f6789.jpg";